module.exports = __webpack_public_path__ + "static/media/news_2.2503e2ba.png";